import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/primeng';
import { AuthService } from '../auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Util } from '../../shared/util';
import { Perfil } from '../../../models/perfis';
import { UnidadeService } from '../../shared/services/unidade.service';

@Component({
  templateUrl: './trocar-perfil.component.html'
})
export class TrocarPerfilComponent implements OnInit {
  public msgs: Message[] = [];

  form;
  projetos;

  unidades = [];
  perfis;

  get tipoPerfilControl() {
    return this.form.controls['tipoPerfil'];
  }
  get idUnidadeControl() {
    return this.form.controls['idUnidade'];
  }

  constructor(private authService: AuthService, private unidadeService: UnidadeService, fb: FormBuilder) {
    this.form = fb.group({
      tipoPerfil: [null, Validators.required],
      idUnidade: [null, Validators.required]
    });
  }

  ngOnInit() {
    this.unidadeService.getUnidades().subscribe((unidades) => (this.unidades = unidades));
  }

  trocarPerfilAtivo() {
    if (
      Util.isNullOrEmptyOrUndefined(this.tipoPerfilControl.value) ||
      Util.isNullOrEmptyOrUndefined(this.idUnidadeControl.value)
    ) {
      this.msgs.push({ severity: 'error', summary: 'Atenção!', detail: 'Ambos campos são obrigatórios.' });
      return;
    }

    const perfilFake = new Perfil();
    perfilFake.Ativo = true;
    perfilFake.ReferenciaPerfil = this.tipoPerfilControl.value;

    const nomeUnidade = this.unidades.find((u) => u.idUnidade === this.idUnidadeControl.value).nomeUnidade;

    this.authService.setPerfilAtivo(perfilFake, this.idUnidadeControl.value, nomeUnidade);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/trocar-perfil/trocar-perfil.component.ts